import { HttpErrorResponse } from '@angular/common/http';

/**
 * Thrown by the HttpErrorInterceptor for requests that failed with HTTP status 0, i.e. requests
 * cancelled by the browser (e.g. during logout or navigation) or blocked before reaching the
 * backend.
 *
 * Gives such failures an identifiable type so the ErrorHandlerService and Sentry can ignore them,
 * while code awaiting the request still gets a rejection instead of an observable that completes
 * empty (which would surface as "EmptyError: no elements in sequence" from firstValueFrom).
 */
export class RequestCancelledError extends Error {
  constructor(readonly response: HttpErrorResponse) {
    super(`Request was cancelled: ${response.url}`);
    this.name = 'RequestCancelledError';
  }
}
